import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { fetchJson } from '@/api';
export const useCategoryStore = create()(devtools(immer((set) => ({
    category: {},
    categoryTree: [],
    filter: {
        subCategories: [],
        manufacturers: [],
        availabilities: [],
        statuses: [],
        attributes: [],
        sort: 'newest',
        price_min: 0,
        price_max: 0,
    },
    clearTrigger: false,
    setFilter: ({ subCategory, manufacturer, availability, status, selectedValue, sort, price_min, price_max, replace }) => {
        set((state) => {
            if (subCategory) {
                const index = state.filter.subCategories.findIndex((id) => id === subCategory);
                if (index === -1) {
                    state.filter.subCategories.push(subCategory);
                }
                else {
                    state.filter.subCategories.splice(index, 1);
                }
            }
            if (manufacturer) {
                const index = state.filter.manufacturers.findIndex((id) => id === manufacturer);
                if (index === -1) {
                    state.filter.manufacturers.push(manufacturer);
                }
                else {
                    state.filter.manufacturers.splice(index, 1);
                }
            }
            if (availability) {
                const index = state.filter.availabilities.findIndex((id) => id === availability);
                if (index === -1) {
                    state.filter.availabilities.push(availability);
                }
                else {
                    state.filter.availabilities.splice(index, 1);
                }
            }
            if (status) {
                const index = state.filter.statuses.findIndex((id) => id === status);
                if (index === -1) {
                    state.filter.statuses.push(status);
                }
                else {
                    state.filter.statuses.splice(index, 1);
                }
            }
            if (selectedValue) {
                const index = state.filter.attributes.findIndex((attr) => attr.id === selectedValue.value.attribute_id);
                if (index === -1) {
                    state.filter.attributes.push({ id: selectedValue.value.attribute_id, values: [selectedValue.value.id] });
                }
                else {
                    const valueIndex = state.filter.attributes[index].values.findIndex((value) => value === selectedValue.value.id);
                    if (valueIndex === -1) {
                        if (replace) {
                            state.filter.attributes[index].values = [selectedValue.value.id];
                        }
                        else {
                            state.filter.attributes[index].values.push(selectedValue.value.id);
                        }
                    }
                    else {
                        state.filter.attributes[index].values.splice(valueIndex, 1);
                    }
                }
            }
            if (sort) {
                state.filter.sort = sort;
            }
            if (price_min) {
                state.filter.price_min = price_min;
            }
            if (price_max) {
                state.filter.price_max = price_max;
            }
        });
    },
    clearFilter() {
        set((state) => {
            state.filter.subCategories = [];
            state.filter.manufacturers = [];
            state.filter.availabilities = [];
            state.filter.statuses = [];
            state.filter.attributes = [];
            state.filter.sort = 'newest';
            state.filter.price_min = 0;
            state.filter.price_max = state.category.price.max;
            state.clearTrigger = !state.clearTrigger;
        });
    },
    set: (category, categoryTree) => {
        set((state) => {
            state.category = category;
            state.categoryTree = categoryTree;
            state.filter.price_max = state.category.price.max;
        });
    },
}))));
export const getCategoryFilter = async (url, id) => {
    const data = await fetchJson(`${url}/${id}`);
    return data.data;
};
export const getCategoryTree = async (url) => {
    const data = await fetchJson(url);
    return data.data;
};
